import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'searchName',
    standalone: true
})
export class SearchNamePipe implements PipeTransform {

    /*
     * search clients with name includes search
     * @params items - array clients
     * @params search - search name
    **/
    transform(items: any[], search: string, fields: string[] = ['name']): any[] {
        return items.filter(it => {
            for (const field of fields) {
                if (it[field]?.toLowerCase().includes(search.toLowerCase())) {
                    return true;
                }
            }
            return false;
        });
    }
}
